

export function mykeywordAdd(keyword, callback) {
	return {
    type: 'MY_KEYWORD_ADD',
		payload: {
			keyword: keyword,
		},
		callback: callback,
	}
}

export function mykeywordDel(id) {
	return {
		type: "MY_KEYWORD_DEL",
		payload: {
			id: id,
		},
	}
}
